module.exports = __webpack_public_path__ + "media/6.c987f7cd.mp3";